<template>
  <div class="form-thumbnail">
    <BannerDropzone
      v-if="!inputValue"
      :name="name"
      :type="type"
      :error="errorMsg"
      @on-uploading-complete="onUploadingComplete"
    />
    <MediaPreview
      v-else
      class="media-preview-wrapper"
      :src="inputValue"
      :disabled="disabled"
      helper-text="For the header of the drop page."
      @on-delete="onDelete"
    />
  </div>
</template>

<script>
import { useField } from 'vee-validate';

import { MediaPreview, BannerDropzone } from '@/components/common/files';

export default {
	components: {
		MediaPreview,
		BannerDropzone,
	},
	props: {
		name: {
			type: String,
			required: true,
		},
		value: {
			type: String,
			required: false,
			default: '',
		},
		type: {
			type: String,
			required: false,
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	setup (props) {
		const {
			value: inputValue,
			errorMessage,
			handleChange,
		} = useField(props?.name || '', undefined, {
			initialValue: props?.value,
		});

		return {
			inputValue,
			handleChange,
			errorMessage,
		};
	},
	computed: {
		errorMsg () {
			return this?.errorMessage || '';
		},
		isHasErrorMessage () {
			return !!this.errorMsg;
		},
	},
	methods: {
		onUploadingComplete (file) {
			this.handleChange(file?.url || '');
		},
		onDelete () {
			this.handleChange('');
		},
	},
};
</script>

<style scoped lang='scss'>
  .media-preview-wrapper {
    :deep(.media-preview) {
      width: fit-content;
      height: 110px;
    }
  }
</style>
